import Swal from "sweetalert2"
import { toast } from "react-toastify"
import { ICandidatModel } from "@common-models/*"
import { CONST_API_RECRUITMENT_CANDIDATES_POST_REMOVE_FROM_VIVIERS } from "../../../endpoints"
import axios from "axios"

const useCandidat = () => {
     function removeFromViviers(
          candidats: ICandidatModel[],
          viviers_ids: number[],
          onConfirmCallback?: () => void,
          onSuccessCallback?: () => void,
          onDismissCallback?: () => void,
          onErrorCallback?: () => void
     ) {
          const candidats_ids = candidats.map(item => item.id)

          Swal.fire({
               icon: "warning",
               title: `${candidats_ids.length > 1 ? "Plusieurs candidats seront supprimés" : "Un candidat sera supprimé"} ${viviers_ids.length > 1 ? "des viviers" : "du vivier"}`,
               showCancelButton: true,
               confirmButtonText: "Confirmer",
               cancelButtonText: "Annuler",
               focusConfirm: true,
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    if (onConfirmCallback) onConfirmCallback()

                    return axios
                         .post(CONST_API_RECRUITMENT_CANDIDATES_POST_REMOVE_FROM_VIVIERS, { candidats_ids, viviers_ids })
                         .then(() => {
                              if (onSuccessCallback) onSuccessCallback()
                              toast.success(
                                   `${candidats_ids.length > 1 ? "Les candidats ont bien été supprimés" : "Le candidat a bien été supprimé"} ${
                                        viviers_ids.length > 1 ? "des viviers" : "du vivier"
                                   }`,
                                   { autoClose: false }
                              )
                         })
                         .catch((e: any) => {
                              if (onErrorCallback) onErrorCallback()
                              toast.error(e?.response?.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !Swal.isLoading(),
          }).then(result => {
               if (result.isDismissed && onDismissCallback) onDismissCallback()
          })
     }

     return { removeFromViviers }
}

export default useCandidat
